import { useIsFeatureOn } from "@somewear/feature";
import { someFeatures } from "@somewear/model";
import Config from "@web/config/Config";

export function useIsMapEnabled() {
	const isMapboxDisabled = useIsFeatureOn(someFeatures.DISABLE_MAPBOX);
	const isMapEnabledInConfig = Config.somewear.map.enable;

	return !isMapboxDisabled && isMapEnabledInConfig;
}
